import {
  START_LOADING,
  END_LOADING,
  FETCH_ACCOUNTING_SETTINGS,
  FETCH_ACCOUNTING_PERIODS,
  UPDATE_ACCOUNTING_PERIOD,
  UPDATE_ACCOUNTING_SETTINGS,
  ACCOUNTING_SETTINGS_ERROR,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  accountingSettings: {},
  accountingPeriods: [],
  error: null,
};

const accountingSettings = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true, error: null };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_ACCOUNTING_SETTINGS:
      return { ...state, accountingSettings: action.payload };
    case FETCH_ACCOUNTING_PERIODS:
      return { ...state, accountingPeriods: action.payload };
    case UPDATE_ACCOUNTING_PERIOD: {
      const updatedPeriod = action.payload;
      const existingPeriods = state.accountingPeriods || [];
      const hasPeriod = existingPeriods.some((period) => period._id === updatedPeriod?._id || period.period === updatedPeriod?.period);
      return {
        ...state,
        accountingPeriods: hasPeriod
          ? existingPeriods.map((period) =>
            period._id === updatedPeriod?._id || period.period === updatedPeriod?.period ? updatedPeriod : period,
          )
          : [updatedPeriod, ...existingPeriods],
      };
    }
    case UPDATE_ACCOUNTING_SETTINGS:
      return { ...state, accountingSettings: action.payload };
    case ACCOUNTING_SETTINGS_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export default accountingSettings;
